const EnvironmentName = "prod2022";

const config = {
  prod2022: {
    WaegApiBaseUrl: "http://localhost:3000",
  },
  test2022: {
    WaegApiBaseUrl: "https://devapi.daeg.com.au",
  },
  prod2022: {
    WaegApiBaseUrl: "https://api.daeg.com.au",
  },
};

export default config[EnvironmentName];
